import ContentLayout from '@/layouts/content-layout'
import FeedDetailView from '@/sections/feeds/view/feed-detail-view'

export default function FeedDetail() {
  return (
    <ContentLayout title="ฟีด" backButton>
      <FeedDetailView />
    </ContentLayout>
  )
}
